module.exports = __webpack_public_path__ + "img/unknown.7e3c9aa9.png";